// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"index-module--pageContent--3IDAK","title":"index-module--title--2rx4w","body":"index-module--body--R8aCN","aboutImage":"index-module--aboutImage--cwACA"};